'use strict';

import React, {useCallback, useEffect, useState, useMemo} from 'react';
import {h, Fragment} from 'preact';
import {alert, confirm} from '../../src/desktop/alerts';
import _ from 'underscore';

export default function Items(props) {
    const {refresh, isPage} = props;
    const [items, setItems] = useState(props.basket.items);
    const [quantityUpdateTimer, setQuantityUpdateTimer] = useState(null);

    useEffect(() => {
        setItems(props.basket.items);
    }, [props.basket.items]);

    const remove = useCallback(
        (item, index, ev) => {
            ev.preventDefault();

            // Точно удалить этот товар из корзины?
            confirm(
                trans('cart.alert_delete_message'),
                () => {
                    const onlyAvailable = window.location.href.indexOf('available=1') !== -1;

                    $.post('/basket/delete/', {basket_id: item.id, available: ~~onlyAvailable}, function (response) {
                        if (response.status !== 'success') {
                            return;
                        }

                        const newBasket = {...props.basket};
                        newBasket.items = _.without([...newBasket.items], item);
                        props.setBasket(newBasket);
                    });
                },
                trans('cart.alert_delete_message_caption'),
                trans('cart.alert_delete_message_yes')
            );
        },
        [items, setItems, props.basket]
    );

    const quantityUpdate = useCallback(
        (item, index, mutation) => {
            const onlyAvailable = window.location.href.indexOf('available=1') !== -1;

            const newBasket = {...props.basket};
            newBasket.items[index] = item;
            props.setBasket(newBasket);

            if (quantityUpdateTimer) {
                clearTimeout(quantityUpdateTimer);
            }

            const timer = setTimeout(() => {
                $.post(
                    '/basket/update/',
                    {
                        id: item.product.id,
                        quantity: item.quantity,
                        available: ~~onlyAvailable,
                        mutation: mutation ? 1 : 0,
                    },
                    response => {
                        if (response.hasOwnProperty('status') && response.status === 'success') {
                            refresh();
                        } else {
                            // Произошла ошибка при сохранении количества
                            alert(trans('cart.save_quantity_error'));
                        }
                    }
                );
            }, 1000);

            setQuantityUpdateTimer(timer);
        },
        [props.basket, quantityUpdateTimer, setQuantityUpdateTimer]
    );

    const push = useCallback(
        (item, index, inOnKeyUp, event) => {
            let quantity = ~~event.target.value;

            if (quantity === '' || quantity < 1) {
                if (!inOnKeyUp) {
                    quantity = 1;
                } else {
                    // Don't proceed to updating
                    return;
                }
            }

            if (quantity > 10000) {
                quantity = 10000;
            }

            quantityUpdate({...item, quantity}, index, false);
        },
        [props.basket]
    );

    const spin = useCallback(
        (item, index, type) => {
            let newQuantity = item.quantity;

            if (type === 'minus') {
                newQuantity--;
            } else {
                newQuantity++;
            }

            if (newQuantity < 1) {
                newQuantity = 1;
            } else if (newQuantity >= 10000) {
                newQuantity = 10000;
            }

            quantityUpdate({...item, quantity: newQuantity}, index, false);
        },
        [props.basket]
    );

    if (items.length < 1) {
        {
            /* У Вас нет в корзине товаров */
        }
        return <div className='uvasnettovarov'>{trans('cartLayout.empty')}</div>;
    }

    const ThemeItem = useMemo(() => props.theme, [props.theme]);

    return items.map((item, index) => {
        const product = useMemo(() => item.product, [item.product]);

        return (
            <ThemeItem
                {...{
                    basket: props.basket,
                    index,
                    item,
                    product,
                    remove,
                    push,
                    spin,
                    isPage,
                    isPopup: props.isPopup,
                }}
            />
        );
    });
}
